import { render, staticRenderFns } from "./Opinion.vue?vue&type=template&id=7f304f4f&"
import script from "./Opinion.vue?vue&type=script&lang=js&"
export * from "./Opinion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports